module.exports = __webpack_public_path__ + "assets/img/free.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/free.svg
// module id = 1981
// module chunks = 0